import React, { Component } from 'react';
import { connect } from 'react-redux';
import HeaderLogo from './HeaderLogo';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { getKycStatusAndAdminCommissionCharges, getKycStatusAndAdminCommissionChargesSuccess}  from '../../actions/user';

class UserHeader extends Component {
	constructor(props){
    super(props);
    this.state = {
      user: props.user,
      commission: props.commission,
      status: props.status
    }
    this.bindSlider = this.bindSlider.bind(this);
	}

  componentDidMount(){
    window.addEventListener('load', this.bindSlider);
    if(document.readyState === "complete" || document.readyState === "interactive"){
        this.bindSlider();
    }

    getKycStatusAndAdminCommissionCharges().then((result) => {
      this.props.getKycStatusAndAdminCommissionChargesSuccess(result.data.data);
    })

  }

  bindSlider(){
    const $ = window.$$;
    $(window).scroll(function () {
      if ($(this).scrollTop() > 10) {
        $('#header').addClass('fixedHeader');
      }
      else {
        $('#header').removeClass('fixedHeader');
      }
    });
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.compName == 'Auth' && nextProps.status != this.state.status){
      this.setState({
        user: nextProps.user,
        status: nextProps.status
      });
    }

    if(nextProps.compName == 'kyc_commission' && nextProps.status != this.state.status){
      this.setState({
        commission: nextProps.commission,
        status: nextProps.status
      });
    }
  }

	render() {
    const {user, commission} = this.state;
    let uname = user && user.name;
    let userNameTag = uname.split(/\s/).reduce((response,word)=> response+=word.slice(0,1),'')
    return (
    	<header id="header">
        <div className="container">
          <div className="row align-center">
            <div className="col-md-4 col-xl-2 col-4">
              <HeaderLogo />
            </div>
            <div className="col-md-8 col-xl-10 col-8">
              <div className="header-inner">
                <div className="d-flex align-center justify-end header-right-blk">
                  <div className="marginR30 btn-transfer-money">
                    {
                      commission && commission.kyc_status == 1
                      ?
                      <Link className="btn btn-primary with-icon" to="/transfer-money">Transfer Money</Link>
                      :
                      <Link className="btn btn-primary with-icon" to="/kyc-verification">Transfer Money</Link>
                    }
                  </div>
                  {/*}
                  <div className="notification marginR30">
                    <a className="intimate" href="javascript://"> </a>
                  </div>
                  */}
                  <div className="user-profile d-flex align-center dropdown">
                    <div data-toggle="dropdown"> 
                      <span className="user-pic">
                        <span className="no-img">{userNameTag}</span>
                      </span>
                    </div>
                    <div className="pl-2 name" data-toggle="dropdown">
                      <p className="p16 p-color-3 fw600 primary-txt-color">{user && user.name}</p>
                    </div>
                    <div className="dropdown-menu">
                      <ul>
                        <li><Link className="dropdown-item profile-icon icon" to="/profile">Profile</Link></li>
                        <li><Link className="dropdown-item wallet-icon icon" to="/Wallet">Wallet</Link> </li>
                        <li><Link className="dropdown-item refer-earn-icon icon" to="/refertofriend">Refer & earn</Link> </li>
                        <li><Link className="dropdown-item signout-icon icon" to="/logout">Sign out</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
	}
}

const mapStateToProps = (state) => {
  return {
    commission: {...state.User.commission},
    user: {...state.Auth.user},
    status: state.Auth.status,
    compName: state.Auth.compName
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getKycStatusAndAdminCommissionChargesSuccess: (payload) => {
      dispatch(getKycStatusAndAdminCommissionChargesSuccess(payload));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserHeader);